import { DeepReadonly } from 'utility-types';
import { AppAction } from '..';
import {
  SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_MODAL,
  SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_POPOVER,
  SET_PRIVATE_BULLETIN_HAS_ALREADY_BEEN_PROMOTED_MODAL,
  SET_PRIVATE_BULLETIN_SELECT_PROMOTION_PLAN_MODAL,
  SET_PRIVATE_BULLETIN_MINIMUM_PLAN_MODAL,
  SET_PRIVATE_BULLETIN_PLAN_LOADING_MODAL,
  SET_REDEEM_PROMOTION_PLAN_GRANT_RESULT_MODAL,
  SET_CANCEL_USER_PROMOTION_PLAN_RESULT_MODAL,
} from './types';

export type PrivateUserMonetizationState = DeepReadonly<{
  privateBulletinSuccesfullyPromotedModal: {
    isOpen: boolean;
    bulletinId: string | null;
  };
  privateBulletinSuccesfullyPromotedPopover: {
    isOpen: boolean;
    isPaidAndRunning?: boolean;
    bulletinId?: string | null;
  },
  privateBulletinHasAlreadyBeenPromotedModal: {
    isOpen: boolean;
    bulletinId: string | null;
  };
  privateBulletinSelectPromotionPlanModal: {
    isOpen: boolean;
    bulletinId: string | null;
  };
  privateBulletinMinimumPromotionPlanModal: {
    isOpen: boolean;
    bulletinId: string | null;
  };
  privateBulletinPlanLoadingModal: {
    isOpen: boolean;
  };
  redeemPromotionPlanGrantResultModal: {
    isOpen: boolean;
  };
  cancelUserPromotionPlanResultModal: {
    isOpen: boolean;
  };
}>;

const INITIAL_STATE: PrivateUserMonetizationState = {
  privateBulletinSuccesfullyPromotedModal: {
    isOpen: false,
    bulletinId: null,
  },
  privateBulletinSuccesfullyPromotedPopover: {
    isOpen: false,
    isPaidAndRunning: undefined,
  },
  privateBulletinHasAlreadyBeenPromotedModal: {
    isOpen: false,
    bulletinId: null,
  },
  privateBulletinSelectPromotionPlanModal: {
    isOpen: false,
    bulletinId: null,
  },
  privateBulletinMinimumPromotionPlanModal: {
    isOpen: false,
    bulletinId: null,
  },
  privateBulletinPlanLoadingModal: {
    isOpen: false,
  },
  redeemPromotionPlanGrantResultModal: {
    isOpen: false,
  },
  cancelUserPromotionPlanResultModal: {
    isOpen: false,
  },
};

export const privateUserMonetizationReducer = (state = INITIAL_STATE, action: AppAction): PrivateUserMonetizationState => {
  switch (action.type) {
    case SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_MODAL: {
      return {
        ...state,
        privateBulletinSuccesfullyPromotedModal: {
          isOpen: action.payload.isOpen,
          bulletinId: action.payload.isOpen ? (action.payload.bulletinId || null) : null,
        },
      };
    }
    case SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_POPOVER: {
      return {
        ...state,
        privateBulletinSuccesfullyPromotedPopover: {
          isOpen: action.payload.isOpen,
          isPaidAndRunning: action.payload.isPaidAndRunning || undefined,
          bulletinId: action.payload.isOpen ? (action.payload.bulletinId || null) : null,
        },
      };
    }
    case SET_PRIVATE_BULLETIN_HAS_ALREADY_BEEN_PROMOTED_MODAL: {
      return {
        ...state,
        privateBulletinHasAlreadyBeenPromotedModal: {
          isOpen: action.payload.isOpen,
          bulletinId: action.payload.isOpen ? (action.payload.bulletinId || null) : null,
        },
      };
    }
    case SET_PRIVATE_BULLETIN_SELECT_PROMOTION_PLAN_MODAL: {
      return {
        ...state,
        privateBulletinSelectPromotionPlanModal: {
          isOpen: action.payload.isOpen,
          bulletinId: action.payload.isOpen ? action.payload.bulletinId : null,
        },
      };
    }
    case SET_PRIVATE_BULLETIN_PLAN_LOADING_MODAL: {
      return {
        ...state,
        privateBulletinPlanLoadingModal: {
          isOpen: action.payload.isOpen,
        },
      };
    }
    case SET_PRIVATE_BULLETIN_MINIMUM_PLAN_MODAL: {
      return {
        ...state,
        privateBulletinMinimumPromotionPlanModal: {
          isOpen: action.payload.isOpen,
          bulletinId: action.payload.isOpen && action.payload.bulletin ? action.payload.bulletin.id : null,
        },
      };
    }
    case SET_REDEEM_PROMOTION_PLAN_GRANT_RESULT_MODAL: {
      return {
        ...state,
        redeemPromotionPlanGrantResultModal: {
          isOpen: action.payload.isOpen,
        },
      };
    }
    case SET_CANCEL_USER_PROMOTION_PLAN_RESULT_MODAL: {
      return {
        ...state,
        cancelUserPromotionPlanResultModal: {
          isOpen: action.payload.isOpen,
        },
      };
    }
    default: {
      return state;
    }
  }
};
